/** Secondary performance layered over the authored clips, with bounded radians.
 * Inputs are active simulation seconds and already-smoothed travel. Takeoff and
 * landing use a finite transition envelope; cannon recoil requires a real bolt.
 * The caller restores the authored pose before every sample. */
export function createSkyPilotDynamics() {
  let previousMode = null,
    changedAt = -10,
    previousTime = -1;
  return function apply(state, mode, flight, travel, rotate, reduced) {
    if (state.time < previousTime) {
      previousMode = null;
      changedAt = -10;
    }
    if (previousMode !== null && mode !== previousMode) changedAt = state.time;
    previousMode = mode;
    previousTime = state.time;
    if (reduced) return;
    const age = Math.max(0, state.time - changedAt);
    const transition = age < 0.65 ? Math.sin((Math.PI * age) / 0.65) ** 2 : 0;
    const takeoff = mode === 'Flight' ? transition * flight : 0;
    // A compact launch tuck clears both feet; final grounded contacts remain
    // entirely owned by the Run/Walk animation's authored foot-strike path.
    rotate('spine', -takeoff * 0.13, 0, 0);
    rotate('thighL', takeoff * 0.38, 0, -takeoff * 0.035);
    rotate('thighR', takeoff * 0.25, 0, takeoff * 0.035);
    rotate('shinL', -takeoff * 0.55, 0, 0);
    rotate('shinR', -takeoff * 0.4, 0, 0);
    rotate('upper_armL', -takeoff * 0.16, 0, takeoff * 0.08);
    const braking = Math.max(0, Math.abs(travel.legTurn) - Math.abs(travel.turn));
    const steering = travel.turn - travel.bodyTurn;
    rotate('spine', braking * 0.09 * flight, steering * 0.2 * flight, 0);
    rotate('head', -braking * 0.06 * flight, -steering * 0.26 * flight, 0);
    rotate('upper_armL', braking * 0.2 * flight, 0, -steering * 0.2 * flight);
    rotate('footL', -braking * 0.18 * flight, 0, -steering * 0.12 * flight);
    rotate('footR', -braking * 0.18 * flight, 0, -steering * 0.12 * flight);
    const bolt = state.shots?.findLast((shot) => shot.source === 'player');
    if (!bolt) return;
    const speed = Math.hypot(bolt.vx ?? 0, bolt.vy ?? 0, bolt.vz ?? -(bolt.speed ?? 120));
    const shotAge = (bolt.distance ?? 0) / Math.max(1, speed);
    const kick = shotAge < 0.09 ? Math.sin((Math.PI * shotAge) / 0.09) * 0.045 : 0;
    rotate('upper_armR', kick, 0, -kick * 0.3);
    rotate('forearmR', -kick * 0.7, 0, 0);
    rotate('spine', kick * 0.16, 0, 0);
  };
}
